import { useCustomMutation } from './index';

import { QueryError, QueryKeys } from '../queries';

import Config from '../../config';
import { METHODS } from '../constants';

export const useRefreshSession = () =>
  useCustomMutation<void, QueryError, void>({
    handleData: () => ({
      url: Config.endpoints.REFRESH_SESSION,
      method: METHODS.GET,
    }),
    invalidateKey: QueryKeys.session.SessionStatus,
    errorMessage: 'Refreshing session failed',
    successMessage: 'Session refreshed successfully',
  });
